import AddIcon from "@mui/icons-material/Add";
import { Button, Grid, Stack, Typography, useTheme } from "@mui/material";

type SmallAddButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const SmallAddButton = ({ onClick, disabled = false }: SmallAddButtonProps) => {
  const theme = useTheme();

  return (
    <Grid container rowSpacing={3} columnSpacing={4} mt={0.5} alignItems="center">
      <Grid item xs={11} />
      <Grid item xs={1} container justifyContent="flex-end">
        <Button
          variant="text"
          sx={{
            color: theme.palette.text.primary,
            padding: "0rem",
          }}
          disabled={disabled}
        >
          <Stack direction="row" spacing={1} mt={0.5} justifyItems="center" onClick={onClick}>
            <AddIcon
              sx={{
                fontSize: "1rem",
                marginTop: "0.1rem",
              }}
            />
            <Typography variant="body1">ADD</Typography>
          </Stack>
        </Button>
      </Grid>
    </Grid>
  );
};
